import { apiSlice } from "app/api/apiSlice"

export const domusApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDomusGateways: builder.query({
            query: () => ({ url: 'domus/gateways', method: 'GET' }),
            providesTags: ['DomusGateways']
        }),
        updateGatewayLabel: builder.mutation({
            query: ({ macAddress, label }) => ({
                url: `domus/gateways/${macAddress}`,
                method: 'PATCH',
                body: { label }
            }),
            invalidatesTags: ['DomusGateways']
        })
    })
})

export const {
    useLazyGetDomusGatewaysQuery,
    useUpdateGatewayLabelMutation
} = domusApiSlice
